<template>
    <div class="apprentice-simple-card learning-path-widget">
        <div class="header">
            <h4 class="title">{{ $t('dashboard.new_learning_path') }}</h4>
            <i class="fad fa-book-reader icon"></i>
        </div>
        <div class="body">
            <div
                class="assignments"
                v-if="lpAssignments.length > 0">
                <h5 class="title">{{ $t('dashboard.assignments') }}</h5>
                <ul class="list-unstyled">
                    <li
                        class="assignment"
                        v-for="assignment of lpAssignments"
                        :key="assignment.id">
                        <div class="content">
                            <div class="title">
                                {{ assignment.name }}
                            </div>
                            <b-badge
                                class="lpcategory"
                                pill
                                variant="info">
                                {{ assignment.lp_category.name }}
                            </b-badge>
                        </div>
                    </li>
                </ul>
            </div>

            <div
                class="not-found with-header empty-assignments-list"
                v-else>
                <div
                    class="btn-add-circle icon"
                    v-if="$authUser.isStudent()"
                    title="meld je aan"
                    @click="showLearningPathPage"></div>
                <div class="alert-notice">{{ $t('dashboard.no_assignments_found') }}</div>
            </div>
        </div>
        <a
            class="clickable"
            href="/learning-path/profile"></a>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-learning-path-widget-component',
    props: {
        lpAssignments: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
    },
    methods: {
        showLearningPathPage() {
            window.location.href = this.routes.learningPath();
        },
    },
};
</script>

<style scoped lang="scss">
.learning-path-widget {
    position: relative;

    .header {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        height: 72px;
        margin-left: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        margin-right: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        margin-top: -#{map-get($grid-gutter-spacing, 'twenty-one')};
        padding-right: map-get($grid-gutter-spacing, 'twenty-one');
        border-bottom: 1px solid $border-color;

        .title {
            margin-bottom: 0;
        }

        .icon {
            font-size: 2.1875rem;
            color: $primary;
            border-radius: 50%;
            border: 1px solid $primary;
            padding: map-get($grid-gutter-spacing, 'fifteen');
            position: absolute;
            left: 21px;
            top: 34px;
            background-color: $white;
        }
    }

    .body {
        margin-top: 42px;
    }

    &:hover {
        .header .title {
            color: $primary;
        }
    }
}

.assignments {
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .assignment {
        display: flex;
        flex-direction: row;
        column-gap: map-get($grid-gutter-spacing, 'eight');
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 3px;
        padding-bottom: map-get($grid-gutter-spacing, 'ten');

        .content {
            display: flex;
            flex-direction: column;
            flex: 1;

            .title {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: baseline;
                column-gap: map-get($grid-gutter-spacing, 'ten');
                font-weight: $font-weight-medium;
                font-size: $base-font-size;
                margin-bottom: 0;
            }
        }

        .lpcategory {
            align-self: flex-start;
            font-size: 0.6875rem;
            padding: 3px 8px;
        }

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
        }
    }
}

.not-found {
    .icon {
        z-index: 10;
    }
}
</style>
